"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeclineInvitationRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.DeclineInvitationRequestStruct = (0, superstruct_1.type)({
    inviteId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=DeclineInvitationRequest.js.map